export default __webpack_public_path__ + "static/media/Laikos-group.1f5c383c.jpg";